import React, { useMemo, useState } from 'react';
import { blogPosts, featuredPost } from '../../blogs/data/blogData';
import ResourcesHeroSection from './ResourcesHeroSection';
import ResourcesFilterBar from './ResourcesFilterBar';
import ResourcesArticleGrid from './ResourcesArticleGrid';
import { postMatchesPill } from './resourcesData';

const PAGE_SIZE = 9;

const matchesQuery = (post, query) => {
    if (!query.trim()) return true;
    const q = query.trim().toLowerCase();
    return post.title.toLowerCase().includes(q) || (post.excerpt || '').toLowerCase().includes(q);
};

const ResourcesMainSection = () => {
    const [query, setQuery] = useState('');
    const [category, setCategory] = useState('All');
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

    const matches = (post) => postMatchesPill(post, category) && matchesQuery(post, query);

    const featuredVisible = matches(featuredPost) ? featuredPost : null;
    const otherPosts = useMemo(() => blogPosts.filter(p => p.slug !== featuredPost.slug && matches(p)), [category, query]);

    const totalCount = (featuredVisible ? 1 : 0) + otherPosts.length;
    const visiblePosts = otherPosts.slice(0, visibleCount);
    const hasMore = visibleCount < otherPosts.length;

    const handleCategoryChange = (c) => { setCategory(c); setVisibleCount(PAGE_SIZE); };
    const handleQueryChange = (q) => { setQuery(q); setVisibleCount(PAGE_SIZE); };

    return (
        <>
            <ResourcesHeroSection query={query} onQueryChange={handleQueryChange} />
            <ResourcesFilterBar active={category} onChange={handleCategoryChange} />
            <ResourcesArticleGrid
                featured={featuredVisible}
                totalCount={totalCount}
                visiblePosts={visiblePosts}
                hasMore={hasMore}
                onShowMore={() => setVisibleCount(v => v + PAGE_SIZE)}
            />
        </>
    );
};

export default ResourcesMainSection;
